import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import AppShell from "../components/AppShell";
import UserActionsBar from "../components/UserActionsBar";
import ChangePasswordModal from "../components/ChangePasswordModal";
import TwoFactorSetupModal from "../components/TwoFactorSetupModal";

import { logout as logoutApi } from "../services/api";

function ModuleIcon({ type }) {
  const common = {
    width: 56,
    height: 56,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { display: "block" },
  };

  if (type === "llm") {
    return (
      <svg {...common}>
        <path
          d="M9 3v2m6-2v2M9 19v2m6-2v2M3 9h2m14 0h2M3 15h2m14 0h2"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <rect
          x="7"
          y="7"
          width="10"
          height="10"
          rx="2.2"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <path
          d="M10 11h4M10 13h4"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (type === "brands") {
    return (
      <svg {...common}>
        <path
          d="M7 7.5c0-2 1.6-3.5 3.6-3.5h2.8c2 0 3.6 1.5 3.6 3.5v9c0 2-1.6 3.5-3.6 3.5h-2.8C8.6 20.5 7 19 7 17V7.5Z"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <path
          d="M9.5 9h5M9.5 12h5M9.5 15h3.5"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (type === "cost") {
    return (
      <svg {...common}>
        <path
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Z"
          stroke="currentColor"
          strokeWidth="1.7"
        />
        <path
          d="M12 6v1.5M12 16.5V18"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M9.5 9.5c0-1.1.9-2 2.5-2s2.5.9 2.5 2c0 1.2-1 1.8-2.5 2.2-1.5.4-2.5 1-2.5 2.3 0 1.1.9 2 2.5 2s2.5-.9 2.5-2"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (type === "admin") {
    return (
      <svg {...common}>
        <path
          d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
          stroke="currentColor"
          strokeWidth="1.7"
        />
        <path
          d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    );
  }

  if (type === "analyses") {
    return (
      <svg {...common}>
        <path
          d="M4 4h16v16H4z"
          stroke="currentColor"
          strokeWidth="1.7"
          rx="2"
          fill="none"
        />
        <path
          d="M4 9h16M9 9v11"
          stroke="currentColor"
          strokeWidth="1.7"
        />
        <path
          d="M12 12h5M12 15h4"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (type === "citations") {
    return (
      <svg {...common}>
        <path
          d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
    );
  }

  // ads
  return (
    <svg {...common}>
      <path
        d="M4.5 11.2v1.6c0 1 .8 1.8 1.8 1.8h1.2l1.1 3.1c.2.6.7 1 1.4 1h.4c.8 0 1.4-.6 1.3-1.4l-.5-2.7h2.2l5.8 2.3c.9.4 1.9-.3 1.9-1.3V9.9c0-1-1-1.7-1.9-1.3L14.6 11H6.3c-1 0-1.8.8-1.8 1.8Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M18.2 10.2c.8.6 1.3 1.5 1.3 2.6s-.5 2-1.3 2.6"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function ModuleSelectPage({ currentUser, onLogout }) {
  const navigate = useNavigate();
  const [pwModalOpen, setPwModalOpen] = useState(false);
  const [tfaModalOpen, setTfaModalOpen] = useState(false);

  const userLabel = currentUser?.full_name || currentUser?.email || "User";

  const doLogout = async () => {
    try {
      await logoutApi();
    } finally {
      onLogout?.();
      navigate("/login", { replace: true });
    }
  };

  const openPwModal = () => setPwModalOpen(true);
  const closePwModal = () => setPwModalOpen(false);

  useEffect(() => {
    const isTypingTarget = (el) => {
      if (!el) return false;
      const tag = (el.tagName || "").toLowerCase();
      return tag === "input" || tag === "textarea" || tag === "select" || el.isContentEditable;
    };

    const onKeyDown = (e) => {
      if (e.defaultPrevented) return;

      const key = (e.key || "").toLowerCase();

      if (key === "escape") {
        if (pwModalOpen) {
          e.preventDefault();
          closePwModal();
        }
        return;
      }

      if (e.ctrlKey || e.metaKey || e.altKey) return;
      if (isTypingTarget(e.target)) return;

      if (key === "p") {
        e.preventDefault();
        openPwModal();
        return;
      }

      if (key === "l" && currentUser?.llm_access !== false) {
        e.preventDefault();
        navigate("/analyses");
        return;
      }

      if (key === "a" && currentUser?.ads_access !== false) {
        e.preventDefault();
        navigate("/ads");
        return;
      }

      if (key === "b") {
        e.preventDefault();
        navigate("/brands-hub");
        return;
      }

      if (key === "c" && currentUser?.is_admin) {
        e.preventDefault();
        navigate("/cost");
        return;
      }

      if (key === "m" && currentUser?.is_admin) {
        e.preventDefault();
        navigate("/admin");
        return;
      }

      if (key === "i") {
        e.preventDefault();
        navigate("/citations");
        return;
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [navigate, pwModalOpen, currentUser?.is_admin, currentUser?.llm_access, currentUser?.ads_access]);

  const Tile = ({ kind, title, desc, ctaClass, ctaText, onOpen, shortcut, locked, lockLabel }) => (
    <div
      style={{
        background: locked ? "#f9fafb" : "#fff",
        border: locked ? "1px solid #e5e7eb" : "1px solid var(--border)",
        borderRadius: 16,
        padding: 18,
        boxShadow: locked ? "none" : "0 10px 24px rgba(15,23,42,0.08)",
        display: "flex",
        flexDirection: "column",
        gap: 12,
        opacity: locked ? 0.6 : 1,
        cursor: locked ? "not-allowed" : "default",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
        <div
          style={{
            width: 72,
            height: 72,
            borderRadius: 18,
            display: "grid",
            placeItems: "center",
            background: locked
              ? "linear-gradient(135deg, rgba(107,114,128,0.7), rgba(75,85,99,0.6))"
              : "linear-gradient(135deg, rgba(0,0,0,0.92), rgba(17,24,39,0.88))",
            color: locked ? "#9ca3af" : "#ffcc33",
            boxShadow: locked ? "none" : "0 14px 30px rgba(0,0,0,0.22)",
            border: locked ? "1px solid rgba(107,114,128,0.2)" : "1px solid rgba(255,204,51,0.25)",
            flex: "0 0 auto",
          }}
          aria-hidden="true"
        >
          <ModuleIcon type={kind} />
        </div>

        <div style={{ minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <h3 style={{ margin: 0, marginBottom: 4 }}>{title}</h3>
            {locked && (
              <span style={{
                fontSize: 11, fontWeight: 600, color: "#6b7280", background: "#f3f4f6",
                border: "1px solid #e5e7eb", borderRadius: 6, padding: "2px 8px", whiteSpace: "nowrap",
              }}>
                {lockLabel || "No access"}
              </span>
            )}
          </div>
          <p style={{ margin: 0, color: "#6b7280", fontSize: 13, lineHeight: 1.45 }}>
            {desc}
          </p>
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", gap: 10 }}>
        <div style={{ fontSize: 12, color: "#6b7280", alignSelf: "center" }}>
          {locked ? "" : (<>Shortcut: <span style={{ fontWeight: 800, color: "#111827" }}>{shortcut}</span></>)}
        </div>

        <button
          className={ctaClass}
          onClick={locked ? undefined : onOpen}
          disabled={locked}
          style={{ padding: "10px 18px" }}
        >
          {ctaText}
        </button>
      </div>
    </div>
  );

  return (
    <AppShell
      headerSubtitle={`Modules Hub • Logged in as ${userLabel}`}
      headerRight={
        <UserActionsBar
          mode="hub"
          currentUser={currentUser}
          onChangePassword={openPwModal}
          onSecurity={() => setTfaModalOpen(true)}
          onLogout={doLogout}
        />
      }
    >
      <header className="page-header">
        <div>
          <h1 className="page-title">Select a module</h1>
          <p className="page-sub">Choose what you want to work on next.</p>
        </div>
      </header>

      <main style={{ marginTop: 10 }}>
        {/* ── Core Modules ── */}
        <div style={{ marginBottom: 6 }}>
          <span style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: "#9ca3af" }}>Modules</span>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 18, marginBottom: 28 }}>
          <Tile
            kind="llm"
            title="LLM Discovery"
            desc="Run brand audits across LLMs, review the answer matrix, and generate analyses with MAD Pilot."
            ctaClass="btn-primary"
            ctaText="Open LLM Discovery"
            onOpen={() => navigate("/analyses")}
            shortcut="L"
            locked={currentUser?.llm_access === false}
          />
          <Tile
            kind="ads"
            title="Ads Discovery"
            desc="Ingest ads and browse ad information."
            ctaClass="btn-primary"
            ctaText="Open Ads Discovery"
            onOpen={() => navigate("/ads")}
            shortcut="A"
            locked={currentUser?.ads_access === false}
          />
        </div>

        {/* ── Intelligence ── */}
        <div style={{ marginBottom: 6 }}>
          <span style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: "#9ca3af" }}>Intelligence</span>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 18, marginBottom: 28 }}>
          <Tile
            kind="analyses"
            title="Analysis Hub"
            desc="Browse all LLM Discovery analyses organized by brand. View full reports and export."
            ctaClass="btn-secondary"
            ctaText="Open Analysis Hub"
            onOpen={() => navigate("/analyses")}
            shortcut="H"
          />
          <Tile
            kind="citations"
            title="Citations"
            desc="Explore which domains and URLs are cited by LLMs when answering about your brands."
            ctaClass="btn-secondary"
            ctaText="Open Citations"
            onOpen={() => navigate("/citations")}
            shortcut="I"
          />
          <Tile
            kind="brands"
            title="Brands Management"
            desc="Global view of brands and module enablement (LLM / Ads). Rename and toggle access safely."
            ctaClass="btn-secondary"
            ctaText="Open Brands Hub"
            onOpen={() => navigate("/brands-hub")}
            shortcut="B"
          />
        </div>

        {/* ── Administration ── */}
        <div style={{ marginBottom: 6 }}>
          <span style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: "#9ca3af" }}>Administration</span>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 18 }}>
          <Tile
            kind="admin"
            title="Admin Management"
            desc="User accounts, system configuration, API key status, and integrations."
            ctaClass="btn-secondary"
            ctaText="Open Admin Panel"
            onOpen={() => navigate("/admin")}
            shortcut="M"
            locked={!currentUser?.is_admin}
            lockLabel="Admin only"
          />
          <Tile
            kind="cost"
            title="Cost Control"
            desc="Track LLM spend by provider, model, and module. Manage model prices."
            ctaClass="btn-secondary"
            ctaText="Open Cost Control"
            onOpen={() => navigate("/cost")}
            shortcut="C"
            locked={!currentUser?.is_admin}
            lockLabel="Admin only"
          />
        </div>
      </main>

      <ChangePasswordModal open={pwModalOpen} onClose={closePwModal} />
      <TwoFactorSetupModal open={tfaModalOpen} onClose={() => setTfaModalOpen(false)} />
    </AppShell>
  );
}
